import { render, staticRenderFns } from "./directory.vue?vue&type=template&id=1962f63b&scoped=true"
import script from "./directory.vue?vue&type=script&lang=ts"
export * from "./directory.vue?vue&type=script&lang=ts"
import style0 from "./directory.vue?vue&type=style&index=0&id=1962f63b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1962f63b",
  null
  
)

export default component.exports